/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useState } from 'react';
import Shimmer from 'sushiweb/Shimmer';

import { reasonModel } from '../../../api';
import { InvalidSearchImg } from '../../../images/images';
import { Label, Modal, ModalHeader } from '../../../UiKit';
import { EmptyState } from '../../commons';
import { getFullDate } from '../../commons/CommonMethods';
import { ChevronDown, ChevronUp } from 'sushiweb/Icons';
import { grey } from 'sushiweb/tokens/color';
import { popUpClosedEvent, popUpOpenendEvent } from '../../../analytics/events';
import {
  EventType,
  FeatureName,
  MetricsForJumboEvent,
} from '../../../analytics/constants';

const itemInfoParams = [
  'Item Name, Quantity',
  'Item Price',
  'Issue Quantity',
  'Resolution',
  'Grievance Amt',
];

function PreviousIssuesV1({ orderId }) {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
    popUpClosedEvent({
      event_type: EventType.CLICK,
      feature_name: FeatureName.VIEW_ISSUES,
      [MetricsForJumboEvent.order_id]: orderId,
    });
  };

  return (
    <>
      {showModal ? (
        <PreviousIssuesModal orderId={orderId} handleClose={handleClose} />
      ) : null}
      <p
        className='tw-text-base-green tw-text-[1.4rem] tw-font-medium pointer tw-whitespace-nowrap'
        onClick={() => {
          setShowModal(true);
          popUpOpenendEvent({
            event_type: EventType.CLICK,
            feature_name: FeatureName.VIEW_ISSUES,
            [MetricsForJumboEvent.order_id]: orderId,
          });
        }}
      >
        View All Issues
      </p>
    </>
  );
}

export { PreviousIssuesV1 };

function PreviousIssuesModal({ orderId, handleClose }) {
  return (
    <Modal
      isVisible
      isMaxContent
      padding='0'
      paddingTop='1rem'
      maxHeight='60vh'
      showCloseIcon={false}
      showScrollBar={true}
      titleComponent={
        <div className='tw-w-full tw-m-8 tw-mb-0'>
          <ModalHeader
            title='Order Complaint Details'
            textColor={'#000'}
            handleClose={handleClose}
          />
        </div>
      }
      containerStyles={{ margin: '16px 0 20px 0', padding: '0 20px' }}
      titleStyle={{
        fontSize: '17px',
        fontWeight: '900',
        marginLeft: '-0.4rem',
      }}
      handleClose={handleClose}
    >
      <PreviousIssuesList orderId={orderId} />
    </Modal>
  );
}

function ItemInfoList({ issue }) {
  return (
    <div
      className='tw-w-full tw-h-full tw-flex tw-flex-col  tw-border-[1px] tw-border-solid  tw-border-[#B6DEE0] tw-rounded-xl tw-bg-white tw-cursor-auto'
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className='tw-w-full tw-flex tw-justify-between tw-items-start [&>div]:tw-text-200 [&>div]:tw-font-regular tw-gap-10 [&>div]:tw-text-black tw-p-5  [&>div]:tw-h-full  [&>div]:tw-flex [&>div]:tw-items-start [&>div]:tw-justify-start tw-bg-[#E5F3F3] tw-rounded-tl-xl tw-rounded-tr-xl tw-text-grey-900 '>
        {itemInfoParams?.map((param, ind) => {
          return (
            <div className='tw-w-[20%]' key={ind}>
              {param}
            </div>
          );
        })}
      </div>
      {issue?.item_info?.map((item, ind) => {
        return (
          <div
            className='tw-w-full tw-h-full tw-flex tw-flex-col '
            key={`${item.product_name}_${ind}`}
          >
            <div className='tw-w-full tw-flex tw-justify-between tw-items-start [&>div]:tw-text-200 [&>div]:tw-font-medium tw-gap-10 [&>div]:tw-text-grey-600  [&>div]:tw-w-1/5 [&>div]:tw-flex [&>div]:tw-items-start [&>div]:tw-justify-start tw-p-5 tw-border-[1px] tw-border-solid tw-border-[#F8F9FC] tw-border-b-0 tw-border-x-0 [&>div]:tw-break-all'>
              <div className='tw-flex tw-flex-col tw-gap-1 '>
                <div className='tw-text-black tw-font-medium tw-text-200 [&>div]:tw-break-all'>
                  {item.product_name || '-'}
                </div>
                <div className='tw-text-200 [&>div]:tw-break-all'>
                  Ordered Qty: {item.ordered_quantity || '-'}
                </div>
              </div>
              <div> {item.price ? `₹ ${item.price}` : '-'}</div>
              <div>{item.issue_quantity || '-'} </div>
              <div>{item.resolution_type || '-'}</div>
              <div>
                {item.product_grievance_amt
                  ? `₹ ${item.product_grievance_amt}`
                  : '-'}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

function IssueInfoDetails({ issue }) {
  return (
    <div className='tw-w-full tw-flex'>
      <div className='tw-w-[98%] tw-flex tw-justify-between tw-items-start [&>div]:tw-text-200 [&>div]:tw-font-medium tw-gap-10 [&>div]:tw-text-[#363636] [&>div]:tw-flex [&>div]:tw-items-start [&>div]:tw-justify-start [&>div]:tw-break-all '>
        <div className='tw-flex tw-flex-col tw-w-[18%] tw-flex-wrap '>
          <div className='tw-text-black tw-font-medium tw-text-200 tw-break-all'>
            {issue.complaint_id || '-'}
          </div>
          <div className='tw-text-orange-500 tw-text-100 tw-font-medium tw-break-all'>
            {issue.complaint_type || '-'}
          </div>
        </div>
        <div className='tw-w-[22%]'>
          {issue.created_at ? getFullDate(issue.created_at) : '-'}
        </div>
        <div className='tw-w-1/5' data-dd-privacy='mask'>
          {issue.created_by || '-'}
        </div>
        <div className='tw-w-[10%]'>{issue.resolve_flow || '-'}</div>
        <div className='tw-w-[10%]'>
          {issue.total_amt ? `₹ ${issue.total_amt}` : '-'}
        </div>
        <div className='tw-w-[20%]'>
          <Label
            title={
              issue.complaint_time_karma?.karma +
              issue.complaint_time_karma?.karma_score
            }
            bgColor={issue.complaint_time_karma?.karma_btn_color}
            textColor={issue.complaint_time_karma?.karma_txt_color}
          />
        </div>
      </div>
      {issue?.item_info?.length ? (
        <div className='tw-w-[2%]'>
          {issue.show_item_details ? (
            <ChevronUp size={16} color={grey.z500} />
          ) : (
            <ChevronDown size={16} color={grey.z500} />
          )}
        </div>
      ) : null}
    </div>
  );
}

function PreviousIssuesList({ orderId }) {
  const [error, setError] = useState(null);
  const [issueList, setIssueList] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const res = await reasonModel.getAllIssues(orderId);
      if (res?.isError) {
        setError(res);
      }

      if (res.issues.length) {
        for (let i = 0; i < res.issues.length; i++) {
          res.issues[i].show_item_details = false;
        }
        setIssueList(res.issues);
      }
    };
    setIsLoading(true);
    fetchData().then(() => setIsLoading(false));
  }, [orderId]);

  const handleItemsInfoVisibility = (issues, ind) => {
    const updatedIssue = {
      ...issues[ind],
      show_item_details: !issues[ind].show_item_details,
    };
    issues.splice(ind, 1, updatedIssue);
    const updatedIssuesData = issues;
    setIssueList([...updatedIssuesData]);
  };

  if (isLoading)
    return (
      <Shimmer
        height='20rem'
        width={window.dashboard.mode == 'smartplug' ? '90vw' : '50vw'}
      />
    );

  if (error) {
    <div
      className={` ${
        window.dashboard.mode == 'smartplug' ? 'tw-w-[90vw]' : 'tw-w-[50vw] '
      }`}
    >
      <EmptyState
        img={InvalidSearchImg}
        heading={error?.message || 'No issueList available!'}
        isPop={true}
      />
      ;
    </div>;
  }

  if (!issueList || !issueList?.length) {
    return (
      <div
        className={` ${
          window.dashboard.mode == 'smartplug' ? 'tw-w-[90vw]' : 'tw-w-[50vw] '
        }`}
      >
        {' '}
        <EmptyState
          img={InvalidSearchImg}
          heading={'User has not raised any issues on this order.'}
          isPop
        />
      </div>
    );
  }

  return (
    <div className='tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-3'>
      <div className='tw-w-[99%] tw-flex tw-justify-between tw-items-start [&>div]:tw-text-300 tw-font-medium tw-gap-10 [&>div]:tw-text-grey-700 tw-p-5 tw-rounded-xl [&>div]:tw-h-full  [&>div]:tw-flex [&>div]:tw-items-start [&>div]:tw-justify-start '>
        <div className='tw-w-[18%] '>Complaint ID, Type</div>
        <div className='tw-w-[22%]'>Created At</div>
        <div className='tw-w-[20%]'>Created By</div>
        <div className='tw-w-[10%]'>Resolution Type</div>
        <div className='tw-w-[10%]'>Grievance Amt</div>
        <div className='tw-w-[20%]'> Complaint Time Karma</div>
      </div>
      {issueList.map((issue, ind) => {
        return (
          <div
            className={`tw-w-full tw-flex tw-flex-col tw-border-[1px] tw-border-solid  hover:tw-border-[#E0E4EB] tw-border-indigo-050 tw-rounded-xl tw-bg-indigo-050 `}
            key={`${issue.complaint_id}_${ind}`}
          >
            <div
              className={`tw-w-full tw-flex tw-flex-col  tw-p-5 tw-gap-5 ${
                issue?.item_info?.length ? 'tw-cursor-pointer' : ''
              } tw-relative  ${issue.status ? 'tw-pb-0' : ''}`}
              onClick={() => {
                handleItemsInfoVisibility(issueList, ind);
              }}
            >
              <IssueInfoDetails issue={issue} />
              {issue.show_item_details && issue?.item_info?.length ? (
                <ItemInfoList issue={issue} />
              ) : null}
            </div>

            {issue.status ? (
              <div className='tw-text-[1rem] tw-font-bold tw-bottom-0 tw-left-0 tw-right-0 tw-w-full tw-bg-indigo-100 tw-text-grey-900 tw-border-solid   tw-border-indigo-050 tw-rounded-b-xl tw-px-5 tw-py-1 tw-mt-2 tw-flex tw-items-center'>
                {issue.status} complaint
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
